
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-records-ui',
  currentProjectVersion: 'static-1.77115',
  depVersions: {
  "crm-records-ui": "static-1.77115",
  "ably-hubspot-js": "static-1.435",
  "ai-components-ui-library": "static-1.4986",
  "apollo-dlb": "static-3.41",
  "apollo-link-hub-http": "static-2.3410",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3045",
  "call-widget-addon": "static-2.26884",
  "calling-global-api": "static-1.56775",
  "calling-internal-common": "static-1.29817",
  "calling-lifecycle-internal": "static-1.58157",
  "card-associated-objects-lib": "static-1.38093",
  "card-associated-objects-lib-legacy": "static-1.5716",
  "card-linked-in-sales-navigator-lib": "static-1.35011",
  "card-preview-highlight-lib": "static-1.69607",
  "card-properties-lib": "static-1.38131",
  "client-types": "static-1.370",
  "commerce-contract-lib": "static-1.5377",
  "copilot-toolkit": "static-1.5591",
  "crm_data": "static-4.86173",
  "crm_ui": "static-5.86131",
  "crm-activity-creator-data": "static-1.40598",
  "crm-activity-creator-interactions-legacy": "static-1.30520",
  "crm-activity-creator-widgets": "static-1.46102",
  "crm-cards": "static-1.38687",
  "crm-cards-sdk": "static-1.37390",
  "crm-cards-test-utils": "static-1.37237",
  "crm-command-handler": "static-1.29968",
  "crm-common-dlb": "static-1.3940",
  "crm-events-data": "static-1.54761",
  "crm-fe-perf": "static-1.21608",
  "crm-legacy-global-containers": "static-1.22428",
  "crm-links": "static-1.4743",
  "crm-message-bus": "static-1.35900",
  "crm-object-map": "static-1.1536",
  "crm-pipeline-approvals-lib": "static-1.18593",
  "crm-timeline": "static-1.83088",
  "crm-timeline-tasks": "static-1.32089",
  "customer-data-communicator": "static-1.39539",
  "customer-data-email": "static-1.15523",
  "customer-data-objects": "static-1.6216",
  "customer-data-properties-shared-msw-handlers": "static-1.6176",
  "customer-data-sidebar": "static-2.40260",
  "customer-data-tracking": "static-1.5431",
  "data-fetching-client": "static-1.8231",
  "dispatcher": "static-1.111",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.293",
  "feedback-loader": "static-1.26238",
  "foundations-components": "static-1.5789",
  "foundations-theming-specialty": "static-1.650",
  "framework-data-schema-quick-fetch": "static-1.5385",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6932",
  "framework-data-table": "static-2.8241",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.3679",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6626",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3447",
  "hubspot-dlb": "static-2.1317",
  "HubStyleTokens": "static-2.10111",
  "I18n": "static-7.1372",
  "immutable": "static-2.19",
  "jasmine-console-invariants": "static-1.1327",
  "jasmine-immutable": "static-1.1580",
  "jasmine-runner": "static-1.5021",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.4576",
  "MeetingsLib": "static-2.52874",
  "msw": "static-1.39",
  "multi-currency-client-types": "static-1.2670",
  "onboarding-tours": "static-1.13932",
  "PortalIdParser": "static-2.272",
  "quartz": "static-1.5374",
  "quartz-core": "static-1.4593",
  "quick-fetch": "static-1.2831",
  "quotes-ui-lib": "static-1.73507",
  "raven": "static-3.4440",
  "react": "static-7.151",
  "react-dlb": "static-1.51",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-dom": "static-7.85",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4179",
  "recording-review-components-lib": "static-1.25764",
  "reference-resolvers": "static-1.6773",
  "reporting-dlb": "static-1.53876",
  "reporting-testing-lib": "static-1.2893",
  "sales-clients-common": "static-1.45072",
  "settings-ui-lib": "static-1.11184",
  "tinymce": "static-6.5",
  "ui-addon-avatars": "static-2.8058",
  "ui-addon-draggable": "static-2.1196",
  "ui-addon-opt": "static-4.7280",
  "UIComponents": "static-3.7060",
  "universal-associations-select": "static-1.9402",
  "usage-based-billing-components-lib": "static-1.2988",
  "usage-tracker": "static-1.6087",
  "usage-tracker-core": "static-1.5937",
  "webpack-env": "static-1.54",
  "ai-catchup-cards-lib": "static-1.1943",
  "BizOpsCrmUIComponents": "static-1.39908",
  "call-timeline-event": "static-1.50080",
  "calling-error-reporting": "static-1.29823",
  "calling-integration-timeline-event": "static-1.12728",
  "calling-orchestration-shared-library": "static-1.29614",
  "calling-ui-library": "static-1.64076",
  "card-deal-collaborators-lib": "static-1.32168",
  "chatspot-widget-iframe": "static-1.14824",
  "commerce-billing-lib": "static-1.14142",
  "commerce-subscription-lib": "static-1.30510",
  "commerce-tools-ui-lib": "static-1.5990",
  "composer-plugins": "static-1.66133",
  "conversations-inbox-message-history": "static-1.29176",
  "conversations-message-history": "static-1.9710",
  "conversations-thread-view-crm-events": "static-1.28833",
  "crm_components": "static-3.86173",
  "crm_schema": "static-3.86210",
  "crm_universal": "static-1.20355",
  "crm-activity-creator-interaction-window": "static-1.40051",
  "crm-cards-dnd": "static-3.832",
  "crm-cards-global-registry": "static-1.14084",
  "crm-display-components": "static-1.19683",
  "crm-extension": "static-1.35640",
  "crm-legacy-links": "static-1.71059",
  "crm-meetings-components-lib": "static-1.20930",
  "crm-object-preview": "static-1.20746",
  "crm-source-interpretation-lib": "static-1.3888",
  "crm-ui-legacy-tracking-page-view": "static-1.67190",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.459",
  "customer-data-filters": "static-1.46911",
  "customer-data-objects-ui-components": "static-1.11507",
  "customer-data-properties": "static-1.44994",
  "customer-data-property-utils": "static-1.6543",
  "customer-data-reference-ui-components": "static-1.11605",
  "customer-data-rte": "static-1.28471",
  "customer-data-ui-utilities": "static-1.8358",
  "deal-registration-ui": "static-1.29540",
  "deal-splits-cards-ui": "static-1.38962",
  "deal-splits-sidebar": "static-1.38868",
  "draft-email-branding-plugin": "static-2.19718",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.18986",
  "draft-signature-plugin": "static-1.19466",
  "email-confirm-ui": "static-2.4261",
  "EmailSignatureEditor": "static-1.20063",
  "ExportDialog": "static-6.9021",
  "ExtensionInstallHelpers": "static-1.526",
  "file-manager-components": "static-1.17763",
  "FileManagerLib": "static-1.33404",
  "flywheel-feedback-panel-components": "static-1.5900",
  "foundations-assets": "static-1.3539",
  "foundations-theming": "static-1.2933",
  "framework-data-schema-resolvers": "static-1.5480",
  "hubspot-prosemirror": "static-1.13065",
  "HubStyle": "static-2.10420",
  "icons": "static-2.591",
  "in-meeting-experience-ui-components": "static-1.16407",
  "InboxConnectUtils": "static-4.9281",
  "integration-settings-components": "static-1.10073",
  "lead-tracking-lib": "static-1.33208",
  "metrics-js": "static-1.8343",
  "mobile-manifest-mixins": "static-1.334",
  "native-integrations-shared-strings": "static-1.6449",
  "nav-meta": "static-1.25162",
  "object-builder-ui-client": "static-1.41185",
  "partner-shared-view-ui": "static-1.41863",
  "playbooks-modal": "static-1.74800",
  "playlists-lib": "static-1.6403",
  "products-ui-components": "static-1.34765",
  "property-history-panel": "static-1.18878",
  "property-translator": "static-1.4002",
  "react-colorpicker": "static-2.8852",
  "react-immutable-proptypes": "static-2.8",
  "react-rhumb": "static-1.15222",
  "react-select-plus": "static-1.65",
  "reference-resolvers-lite": "static-1.6577",
  "reporting-action-components": "static-1.35537",
  "reporting-data": "static-1.60958",
  "reporting-enablement": "static-1.16314",
  "reporting-ui-components": "static-2.58237",
  "reporting-visualizations": "static-1.53036",
  "rich-text-lib": "static-1.17158",
  "rpc-client-utils": "static-1.3351",
  "SafeStorage": "static-1.3026",
  "SalesContentIndexUI": "static-3.6837",
  "sanitize-text": "static-1.6812",
  "segment-references-panel-lib": "static-1.49657",
  "sequences-crm-events-lib": "static-1.22318",
  "sequences-crm-lib": "static-1.22514",
  "settings-ui-nav": "static-2.8666",
  "SharedI18nStrings": "static-1.162",
  "styled-components": "static-2.40",
  "subscriptions-components": "static-1.40751",
  "timezone-utils": "static-2.3886",
  "transcript-sidebar": "static-1.61835",
  "transmute": "static-2.29",
  "ui-addon-form-validation": "static-1.9649",
  "ui-addon-i18n": "static-1.9536",
  "ui-addon-iframeable": "static-1.7520",
  "ui-addon-scriptloader": "static-1.11002",
  "ui-addon-teams": "static-1.19512",
  "ui-addon-upgrades": "static-9.15771",
  "ui-asset-management-lib": "static-1.8821",
  "ui-business-units-lib": "static-1.7498",
  "ui-extensions-remote-renderer": "static-1.11954",
  "ui-gdpr-components": "static-1.8878",
  "ui-product-approvals": "static-1.23385",
  "ui-shepherd-react": "static-3.8668",
  "ui-suspension-banners-lib": "static-1.5035",
  "usage-tracker-container": "static-1.6077",
  "atom": "static-1.3865",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-render-mixin": "static-1.9",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.43",
  "sanitize": "static-1.2996",
  "hs-promise-rejection-tracking": "static-1.3967",
  "raven-hubspot": "static-1.4747",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.2969",
  "react-redux": "static-7.16",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.2293",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.1651",
  "quartz-webpack": "static-1.1598",
  "ably": "static-1.18",
  "hs-promise-utils": "static-1.4135",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.8340",
  "chatspot-core": "static-1.14830",
  "ContentUtils": "static-1.62579",
  "foundations-theming-base": "static-1.1918",
  "hs-story-utils": "static-1.8014",
  "sassPrefix": "static-1.129",
  "ui-fonts": "static-1.331",
  "ui-images": "static-2.805",
  "graphql": "static-1.58",
  "calling-client-interface": "static-1.69315",
  "calling-cross-tab-library": "static-1.17783",
  "calling-integration-cross-tab": "static-1.16802",
  "calling-integration-sdk-support": "static-1.25028",
  "calling-lifecycle-messages": "static-1.50453",
  "calling-lifecycle-usage-tracker": "static-1.4672",
  "calling-usage-tracker": "static-1.5126",
  "content-assistance-lib": "static-1.6083",
  "conversations-async-data": "static-2.6294",
  "conversations-prop-types": "static-1.6055",
  "conversations-skeleton-state": "static-1.6017",
  "customer-data-content": "static-1.24173",
  "immer": "static-1.33",
  "PatternValidationJS": "static-1.437",
  "self-service-api": "static-1.8813",
  "shared-worker-versioning": "static-1.9691",
  "frontend-preferences-client": "static-1.6499",
  "onboarding-scopes": "static-1.5164",
  "avatar-components": "static-1.1031",
  "campaigns-lib": "static-1.21534",
  "card-payment-highlight-lib": "static-1.31082",
  "commerce-subscription-cards-lib": "static-1.25335",
  "credit-memos-iframe-lib": "static-1.5573",
  "growth-payments-core": "static-1.20579",
  "payment-link-components": "static-1.17884",
  "payments-embed-points-lib": "static-1.8970",
  "persist-promise": "static-1.2367",
  "commerce-shared-components-lib": "static-1.14252",
  "draft-content-plugins": "static-1.23793",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "FireAlarmUi": "static-1.3490",
  "multi-account-crm-panel-lib": "static-1.11540",
  "react-virtualized": "static-2.73",
  "reselect": "static-2.16",
  "sequences-lib": "static-1.5651",
  "superstore": "static-1.3404",
  "ui-partner-confirmation-links-components": "static-1.21198",
  "enrichment-properties-lib": "static-1.9001",
  "inbound-db-properties-service-client": "static-1.2797",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1200",
  "crm-events-components": "static-1.54748",
  "hub-http-contrib": "static-1.1802",
  "prosemirror": "static-1.13",
  "react-dnd-compat": "static-1.3268",
  "task-forms-lib": "static-1.35254",
  "task-queues": "static-1.28039",
  "ui-addon-video-player": "static-1.7397",
  "attribution-sidebar-cards": "static-1.38583",
  "card-crm-attribution-lib": "static-1.49353",
  "card-engagement-attachments-lib": "static-1.67344",
  "card-lists-lib": "static-1.65553",
  "card-past-feedback-lib": "static-1.36077",
  "card-playbooks-lib": "static-1.57627",
  "card-target-account-lib": "static-1.67054",
  "invoices-card-lib": "static-1.51070",
  "location-customization-utils-lib": "static-1.3426",
  "crm-actions": "static-1.4683",
  "redux-toolkit": "static-1.7",
  "customer-data-sidebar-test-utils": "static-1.34938",
  "all-properties-panel-lib": "static-1.2060",
  "card-company-summary-lib": "static-1.13269",
  "card-integration-card-lib": "static-1.67418",
  "crm-events-viz-core": "static-1.27920",
  "crm-events-viz-timeline": "static-1.35584",
  "crm-record-access-management-lib": "static-1.20517",
  "customer-data-filters-ui": "static-1.33096",
  "customer-data-modals": "static-1.3392",
  "framework-scoring-history-panel-lib": "static-1.9794",
  "merge-modal-lib": "static-1.6148",
  "panel-deal-registration-ai-summary-lib": "static-1.21929",
  "predictive-scores-panel": "static-1.24098",
  "property-description-translator": "static-1.2466",
  "redux-mock-store": "static-1.8",
  "crm-object-search-query-utilities": "static-1.5902",
  "inbound-db-meta-service-client": "static-1.2625",
  "collaboration-sidebar": "static-1.51590",
  "outpost": "static-1.2960",
  "pipeline-validation-client-types": "static-1.2726",
  "user-context": "static-1.3778",
  "accounting-extension-card-ui": "static-1.30785",
  "ai-addon-copilot-preview": "static-1.4198",
  "analytics_js": "static-1.3169",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17781",
  "crm-events": "static-1.54755",
  "feedback-schema": "static-1.47888",
  "FileManagerCore": "static-1.33263",
  "flux-actions": "static-1.266",
  "forms-utils-lib": "static-1.9954",
  "FormsCommonComponents": "static-1.80347",
  "FormUrlGenerator": "static-2.3335",
  "getting-started-shared-tasks": "static-1.11498",
  "integrations-lib": "static-1.9833",
  "integrations-tracking-lib": "static-1.4096",
  "MeetingsBase": "static-1.54466",
  "partner-poi-timeline-event": "static-1.34245",
  "project-storage": "static-1.3323",
  "ql-visibility-lib": "static-1.3940",
  "qualified-leads-embedded-lib": "static-1.41846",
  "quotes-crm-events-lib": "static-1.36884",
  "quotes-modal-lib": "static-1.95464",
  "react-table": "static-1.15",
  "report-customization-components": "static-1.8209",
  "reporting-snowflake": "static-1.49580",
  "salesforce-sync-card-ui": "static-1.7565",
  "salesImages": "static-1.498",
  "sequences-client-types-lib": "static-1.5507",
  "share-transcript-modal": "static-1.51480",
  "social-components-lib": "static-1.28351",
  "StyleGuideUI": "static-3.453",
  "svh-tickets-lib": "static-1.13087",
  "ui-addon-integrations-directory-panel": "static-2.6609",
  "ui-addon-react-router-dom": "static-1.8237",
  "ui-addon-sales-email": "static-1.3823",
  "ui-tour-react": "static-1.10584",
  "urlinator": "static-1.3166",
  "hubspot-prosemirror-plugins": "static-1.13057",
  "outreach-assistant-email-generation": "static-1.2380",
  "quotes-client-types": "static-1.30875",
  "sales-email-signature-service-client": "static-1.2626",
  "conditional-properties-service-client": "static-1.2774",
  "external-options-client-types": "static-1.2938",
  "inbounddb-objects-service-types": "static-1.3062",
  "card-subscription-highlight-lib": "static-1.32933",
  "invoices-highlight-card-lib": "static-1.48926",
  "orders-highlight-card-lib": "static-1.16636",
  "products-highlight-card-lib": "static-1.12530",
  "quotes-highlight-card-lib": "static-1.64796",
  "wootric-nps": "static-1.5579",
  "bend-plugin-foundations-components": "static-1.2057",
  "floating-ui": "static-1.28",
  "framer-motion": "static-1.40",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "crm-pipelines-api-client-types": "static-1.2972",
  "framework-builder-read-service-client": "static-1.2910",
  "customer-data-associations": "static-1.5828",
  "testing-library": "static-1.120",
  "HeadJS": "static-2.563",
  "hs-test-utils-bend-plugin": "static-1.1737",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.2971",
  "foundations-components-test-utils": "static-1.3274",
  "laboratory-lib": "static-3.5879",
  "react-transition-group": "static-1.7",
  "redux-actions": "static-3.7",
  "signup-constants": "static-1.15857",
  "signup-ui-lego-core": "static-1.17867",
  "signup-ui-url-generator": "static-2.6671",
  "underscore": "static-1.8",
  "usage-tracker-anonymous": "static-1.4504",
  "usage-tracker-multi": "static-1.4501",
  "usage-tracker-public": "static-1.5898",
  "viral-links-lib": "static-1.5485",
  "ts-schema": "static-1.2990",
  "growth-data-modal": "static-1.3821",
  "growth-onboarding-confetti": "static-1.1728",
  "navigation-components": "static-1.13525",
  "ui-shepherd-tracker": "static-1.6049",
  "ui-universal-auth": "static-1.7419",
  "quartz-core-utils": "static-1.2241",
  "hub-http-janus": "static-1.635",
  "hub-http-shared-msw-handlers": "static-1.6846",
  "hubspotter-http": "static-1.3420",
  "hubspotter-http-shared-msw-handlers": "static-1.6844",
  "platform-navigation-bootstrap": "static-1.11022",
  "csstype": "static-1.38",
  "call-summary": "static-1.31468",
  "object-comments-thread-lib": "static-1.5582",
  "reporting-client-types": "static-1.1767",
  "ui-coaching-tips": "static-1.21906",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9089",
  "rxjs": "static-5.10",
  "react-flip-move": "static-1.46",
  "subscription-experience-data-types": "static-1.10031",
  "crm-properties-list": "static-1.32958",
  "activity-history-lib": "static-1.1328",
  "assisted-buying-components": "static-1.5618",
  "bet-customer-success-shared-ui": "static-1.11660",
  "company-details-components": "static-1.4518",
  "company-details-service-types": "static-1.2549",
  "final-form": "static-1.39",
  "flywheel-recent-conversions-lib": "static-1.998",
  "industries-core": "static-1.5381",
  "payment-method-components": "static-1.5164",
  "quote-checkout-common-lib": "static-1.8932",
  "quote-checkout-service-types": "static-1.2241",
  "conversations-calling-message": "static-1.53856",
  "crm-events-viz-test-utils": "static-1.16541",
  "calling-orchestration-schema": "static-1.29839",
  "onboarding-tours-client": "static-1.3133",
  "twilio-voice-sdk": "static-1.50",
  "worker-connection-library": "static-1.11096",
  "commerce-analytics-service-client": "static-1.2402",
  "cv-backend-services": "static-1.1110",
  "growth-onboarding-empty-states": "static-1.3792",
  "payments-enrollment-embed-lib": "static-1.17058",
  "payments-post-enroll-local-storage-lib": "static-1.3709",
  "qrcode-generator": "static-1.43",
  "conversations-infrastructure": "static-1.7544",
  "conversations-internal-schema": "static-1.11272",
  "conversations-error-reporting": "static-1.7574",
  "composer-data": "static-1.25009",
  "conversations-http": "static-1.3416",
  "conversations-internal-pub-sub": "static-1.14632",
  "conversations-platform": "static-1.3116",
  "conversations-thread-data": "static-1.62169",
  "ui-addon-conversations-settings": "static-2.27008",
  "zorse-crm-components-lib": "static-1.5633",
  "crm-activity-creator-interactions": "static-1.39323",
  "ui-addon-draggable-compat": "static-2.2886",
  "adobe-sign-cards-lib": "static-1.12460",
  "automation-ui-crm-card-workflows-invoker": "static-1.4568",
  "buyer-intent-card": "static-1.15615",
  "card-call-summaries-lib": "static-1.29669",
  "card-customer-spend-trends-lib": "static-1.20551",
  "card-flywheel-activity-history-lib": "static-1.1767",
  "card-flywheel-company-overview-lib": "static-1.10796",
  "card-flywheel-domain-review-history-lib": "static-1.424",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.10796",
  "card-guest-access-management-lib": "static-1.2383",
  "card-guided-execution-activities": "static-1.3765",
  "card-knowledge-base-lib": "static-1.6712",
  "card-lead-insights": "static-1.8926",
  "card-lead-qualification-lib": "static-1.24552",
  "card-object-highlight-lib": "static-1.1068",
  "card-object-summary-lib": "static-1.2737",
  "card-other-tickets-lib": "static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.25371",
  "card-partner-client-unified-usage-score-lib": "static-1.19736",
  "card-prospecting-research-agent": "static-1.1814",
  "card-tasks-timeline-lib": "static-1.9577",
  "card-ticket-summary-lib": "static-1.11424",
  "crm-associations-pivot": "static-1.33912",
  "crm-associations-table": "static-1.35782",
  "crm-clv-report": "static-1.2570",
  "crm-data-highlights": "static-1.36320",
  "crm-events-viz-cards": "static-1.35576",
  "crm-events-viz-totals": "static-1.27129",
  "crm-property-history": "static-1.11018",
  "crm-quick-actions": "static-1.12468",
  "crm-relative-timeline": "static-1.12896",
  "crm-report": "static-1.36527",
  "crm-simple-deadline": "static-1.13114",
  "crm-stage-tracker": "static-1.31491",
  "crm-statistics": "static-1.25536",
  "custom-events-card-lib": "static-1.291",
  "customer-overview-card-lib": "static-1.4139",
  "customer-success-contacts-card-lib": "static-1.12240",
  "deal-summary-components": "static-1.15099",
  "docusign-cards-lib": "static-1.21965",
  "flywheel-growth-plans-crm-card": "static-1.1286",
  "guided-actions-card": "static-1.8799",
  "guided-selling-stage-tracker-card": "static-1.5920",
  "health-score-card-lib": "static-1.15523",
  "help-desk-insights-lib-crm-cards": "static-1.17750",
  "intelligence-overview-card": "static-1.9447",
  "intelligence-overview-lib": "static-1.7699",
  "invoices-history-card-lib": "static-1.25354",
  "lead-scores-card": "static-1.11907",
  "legacy-sidebar-card-lib": "static-1.29119",
  "payment-schedule-card-lib": "static-1.22699",
  "playbooks-card": "static-1.37510",
  "predictive-scores-card": "static-1.25096",
  "process-guide-cards": "static-1.3363",
  "products-cards-lib": "static-1.3839",
  "purchase-history-lib": "static-1.15039",
  "ui-google-drive-attachments": "static-1.1136",
  "ui-google-drive-insights": "static-1.1138",
  "crm-component-utils": "static-1.33933",
  "content-embed-lib": "static-1.5976",
  "remote-ui": "static-1.39",
  "ui-extensions": "static-1.14361",
  "ui-extensions-plugin-flywheel": "static-1.8895",
  "credit-memos-highlight-card-lib": "static-1.4926",
  "deep-diff": "static-1.5",
  "commerce-products-lib": "static-1.4245",
  "google-libphonenumber": "static-1.11",
  "media-bridge-lib": "static-1.16424",
  "video-data-lib": "static-1.28780",
  "FileManagerImages": "static-1.30914",
  "bend-plugin-foundations-theming": "static-1.1416",
  "fast-json-stable-stringify": "static-1.4",
  "knowledge-content-types": "static-1.7617",
  "ui-addon-emoji-picker": "static-1.8547",
  "in-meeting-experience-client-types": "static-1.13107",
  "marketplace-embed": "static-1.15684",
  "crm-record-cards-service-types": "static-1.2640",
  "ui-components-test-utils": "static-1.4251",
  "universal-page-editor-lib": "static-1.1558",
  "card-sales-activities-timeline": "static-1.32238",
  "partner-shared-messages-lib": "static-1.12659",
  "dashboard-lib": "static-1.75057",
  "share-with-third-party-component-lib": "static-1.7272",
  "data-quality-ui-library": "static-1.7392",
  "html-to-image": "static-1.29",
  "reporting-plugins": "static-1.6397",
  "reporting-reports": "static-1.60643",
  "data-token-picker": "static-1.13812",
  "account-and-billing-components": "static-1.16084",
  "growth-feature-usage-components": "static-1.4120",
  "subscriptions-client": "static-1.40991",
  "magpie-lib": "static-1.4303",
  "navigation-messaging": "static-1.2852",
  "feature-store-service-types": "static-1.3289",
  "growth-monetization-service-types": "static-1.3296",
  "upgrade-management-service-types": "static-1.3280",
  "ui-extensibility-client-types": "static-1.2819",
  "cms-field-types": "static-1.3402",
  "content-icons-ui": "static-1.1863",
  "attribution-lib": "static-1.36959",
  "campaigns-build-lib": "static-1.6945",
  "marketing-platform-lib": "static-1.5284",
  "credit-memos-ui-lib": "static-1.5571",
  "commerce-tours-lib": "static-1.3139",
  "growth-onboarding-reliability": "static-1.3770",
  "sales-checkout-service-client": "static-1.2414",
  "breeze-intelligence-kit": "static-1.3833",
  "fsm": "static-1.2321",
  "policy-lib": "static-1.5422",
  "amplitude-session-replay-browser": "static-1.6",
  "flywheel-reject-ql-lib": "static-1.1019",
  "accounting-integrations-ui-components": "static-1.4583",
  "invoices-iframe-lib": "static-1.50999",
  "invoices-ui-lib": "static-1.48941",
  "customer-data-filters-ui-msw-helpers": "static-1.15529",
  "automation-ui-core": "static-2.15293",
  "automation-ui-permissions": "static-1.13655",
  "framework-scoring-client-types": "static-1.10847",
  "markdown-it": "static-1.6",
  "predictive-scores-lib-components": "static-1.22493",
  "getting-started-shared-tasks-store": "static-1.10616",
  "ai-settings-ui-library": "static-1.5669",
  "crm-pipeline-events-ui": "static-1.21883",
  "audio-components": "static-1.4234",
  "video-components": "static-1.7132",
  "video-embed": "static-1.29621",
  "forms-ai-lib": "static-1.2032",
  "react-tinymce": "static-1.49947",
  "SharedLegalStrings": "static-1.1292",
  "tinymce-config": "static-2.49073",
  "integrations-error-boundary-lib": "static-1.7248",
  "meetings-client-types": "static-1.2680",
  "portal-details-components": "static-1.13341",
  "reporting-datasets-permissions-lib": "static-1.6708",
  "growth-onboarding-feedback-components": "static-1.5081",
  "messaging-types-lib": "static-1.39671",
  "products-iframe-lib": "static-1.2270",
  "products-ui-components-shared-msw-handlers": "static-1.7231",
  "emoji-regex": "static-1.7",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3763",
  "simple-logging-lib": "static-1.1665",
  "platform-infra-nav-components": "static-1.6539",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.6992",
  "fintech-buying-service-clients": "static-1.2355",
  "account-and-billing-contacts-usage": "static-2.17542",
  "signup-ui-full-screen-search": "static-1.9996",
  "billing-payments-client-types": "static-1.2703",
  "buying-experience-components": "static-1.8427",
  "checkout-service-types": "static-1.2791",
  "growth-pro-utils-lib": "static-1.7684",
  "trellis-story-utils": "static-1.3177",
  "marketplace-ui-apps-core": "static-1.12002",
  "stripe-embedded-components": "static-1.4947",
  "conversations-routing-lib": "static-1.5588",
  "immutable-less": "static-1.3182",
  "routing-ui": "static-1.15285",
  "conversations-visibility-tools": "static-1.4385",
  "data-ops-fullstory": "static-1.3947",
  "re-reselect": "static-1.4",
  "automation-enrollment-service-types": "static-1.2549",
  "automation-platform-service-types": "static-1.2055",
  "domain-review-history-lib": "static-1.1407",
  "renewal-center-service-types": "static-1.2801",
  "recent-activities-card": "static-1.52612",
  "submissions-lib": "static-1.40841",
  "ui-forms-components": "static-1.7949",
  "prospecting-agent-lib": "static-1.6242",
  "customer-success-client-types": "static-1.14059",
  "sales-enablement-lib": "static-1.11167",
  "sales-leader-insights-components-lib": "static-1.12878",
  "guided-actions-lib": "static-1.14030",
  "property-management-iframe": "static-1.7768",
  "card-bet-associated-companies-lib": "static-1.71068",
  "card-bet-deal-support-requests-lib": "static-1.61809",
  "card-bet-quotes-lib": "static-1.71075",
  "card-biz-ops-customer-success-lib": "static-1.71089",
  "card-biz-ops-domain-controls-lib": "static-1.71090",
  "card-biz-ops-related-contacts-lib": "static-1.71089",
  "card-deal-shared-view-lib": "static-1.62993",
  "card-deal-splits-lib": "static-1.38348",
  "card-flywheel-ql-summary-lib": "static-1.39955",
  "card-flywheel-recent-conversions-lib": "static-1.39956",
  "card-gdpr-subscriptions-card-lib": "static-1.41453",
  "card-invoices-lib": "static-1.50435",
  "card-marketing-event-about-lib": "static-1.50217",
  "card-marketing-event-activity-lib": "static-1.50216",
  "card-past-conversations-lib": "static-1.31981",
  "card-payment-history-lib": "static-1.30947",
  "card-profile-products-lib": "static-1.51109",
  "card-profile-quotes-lib": "static-1.78315",
  "card-prospecting-notes": "static-1.32238",
  "card-qualified-leads-lib": "static-1.71230",
  "card-sfdcsync-lib": "static-1.50287",
  "card-website-activity-lib": "static-1.67869",
  "card-workflows-lib": "static-1.67244",
  "integrations-sync-card-ui": "static-1.21265",
  "marketing-event-cards-ui": "static-1.31194",
  "orders-card-lib": "static-1.16353",
  "partner-poi-crm-card": "static-1.13691",
  "recording-preview-card": "static-1.11114",
  "surveymonkey-crm-card": "static-1.34918",
  "ui-sales-order-wizard-card": "static-1.26250",
  "sales-execution-components": "static-1.7530",
  "process-guide-chirp": "static-1.3195",
  "gapi-client-types": "static-1.3",
  "google-picker-types": "static-1.3",
  "ui-google-drive-picker": "static-1.707",
  "marketplace-ui-client-types": "static-1.10872",
  "marketplace-ui-common": "static-1.13466",
  "marketplace-ui-details": "static-1.3366",
  "trellis-ecosystem": "static-1.4312",
  "campaign-roi-lib": "static-1.2125",
  "account-and-billing-fintech-outages": "static-3.14834",
  "fintech-outages-service-client-types": "static-1.11703",
  "transactions-exp-service-client-types": "static-1.11699",
  "growth-feature-usage-data": "static-1.4339",
  "automation-ui-routing": "static-1.14717",
  "automation-ui-source-apps": "static-1.12439",
  "immerable": "static-1.2789",
  "social-insights-client-types": "static-1.17255",
  "tinymce-themes": "static-1.51043",
  "interframe": "static-3.3421",
  "tinymce-data": "static-1.35158",
  "tinymce-plugins": "static-1.52187",
  "user-configuration-lib": "static-1.23935",
  "ContentData": "static-1.62655",
  "marketing-email-service-types": "static-1.1408",
  "sales-views-client-types": "static-1.2969",
  "ui-signature-editor": "static-1.13228",
  "developer-experience-shared-components": "static-1.8700",
  "stripe-connect-js": "static-1.37",
  "form-builder-ui": "static-1.7723",
  "ui-deal-management-components-lib": "static-1.15164",
  "react-window": "static-1.13",
  "embedded-academy-lib": "static-1.9720",
  "marketplace-ui-reviews": "static-1.13425",
  "marketplace-ui-tracking": "static-1.7640",
  "NamespacedHubStyle": "static-2.8082",
  "codemirror": "static-5.69",
  "layout-dnd-components": "static-1.10559",
  "layout-dnd-utils": "static-1.9534",
  "react-codemirror": "static-1.9223",
  "app-users-service-client": "static-1.3655",
  "app-users-service-types": "static-1.3061",
  "framework-listing-lib": "static-2.21685",
  "mini-checkout-client": "static-1.23824",
  "onboarding-utils": "static-1.3967",
  "ui-coaching-tips-shared-config": "static-1.21891",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2924",
  "academy-common-lib": "static-1.9180",
  "diff-match-patch": "static-1.7",
  "layout-data-lib": "static-1.7859",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.21801",
  "framework-listing-lib-shared-msw-handlers": "static-1.6737",
  "touchless-buying-components": "static-1.3066",
  "merchandise-lib": "static-1.221",
  "settings-content-modals": "static-1.39199",
  "academy-service-client": "static-1.2688",
  "zustand": "static-1.45",
  "crm-export-dialog": "static-1.4926",
  "crm-index-associations-lib": "static-1.4995",
  "react-beautiful-dnd": "static-1.13",
  "checkout-sdk": "static-3.20667",
  "upgrade-catalog-service-types": "static-1.2544",
  "access-control-lib": "static-1.9093",
  "EmailComponents": "static-1.48347",
  "EmailData": "static-1.47023",
  "redux-less": "static-2.8055",
  "hub-http-rxjs": "static-1.602",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "ContentComponents": "static-2.65536",
  "marketing-contacts-lib": "static-1.7755",
  "messaging-editing-lib": "static-1.39935",
  "ui-tool-access": "static-1.8669",
  "automation-ui-types": "static-1.13357",
  "data-token-views": "static-1.13793",
  "simple-menus-core": "static-1.13332",
  "simple-menus-lib": "static-1.14850",
  "ui-memberships-settings-lib": "static-1.27636",
  "videoconference-integration-components": "static-1.4733",
  "automation-applications-service-types": "static-1.2462",
  "ContentEditorUI": "static-2.70973",
  "short-messages-app-service-client": "static-1.2791",
  "web-interactives-components": "static-1.11235",
  "web-interactives-data": "static-1.11236",
  "seamless-immutable": "static-7.6",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3675",
  "copilot-plugins": "static-1.5564",
  "cta-picker": "static-1.30683",
  "editor-components": "static-1.11641",
  "editor-iframe-lib": "static-1.6920",
  "error-messaging-js": "static-1.3912",
  "pictos": "static-7.158",
  "redux-request-state": "static-1.9198",
  "smart-content-core": "static-1.36638",
  "smart-content-lib": "static-1.37291",
  "social-composer-lib": "static-1.52760",
  "structured-content-lib": "static-1.19569",
  "theme-previewer-lib": "static-1.47206",
  "tinymce-copilot": "static-1.11141",
  "ui-active-theme-content-creator-lib": "static-1.31122",
  "xray-recommendation-lib": "static-1.5698",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.4429",
  "ui-brand-identity-lib": "static-1.7800",
  "fuzzy": "static-1.8",
  "codemirror-dlb": "static-1.52527",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-records-ui": "/crm-records-ui/static-1.77115",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.4986",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3410",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3045",
  "call-widget-addon": "/call-widget-addon/static-2.26884",
  "calling-global-api": "/calling-global-api/static-1.56775",
  "calling-internal-common": "/calling-internal-common/static-1.29817",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.58157",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.38093",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.5716",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.35011",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.69607",
  "card-properties-lib": "/card-properties-lib/static-1.38131",
  "client-types": "/client-types/static-1.370",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5377",
  "copilot-toolkit": "/copilot-toolkit/static-1.5591",
  "crm_data": "/crm_data/static-4.86173",
  "crm_ui": "/crm_ui/static-5.86131",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.40598",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.30520",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.46102",
  "crm-cards": "/crm-cards/static-1.38687",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37390",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.37237",
  "crm-command-handler": "/crm-command-handler/static-1.29968",
  "crm-common-dlb": "/crm-common-dlb/static-1.3940",
  "crm-events-data": "/crm-events-data/static-1.54761",
  "crm-fe-perf": "/crm-fe-perf/static-1.21608",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22428",
  "crm-links": "/crm-links/static-1.4743",
  "crm-message-bus": "/crm-message-bus/static-1.35900",
  "crm-object-map": "/crm-object-map/static-1.1536",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.18593",
  "crm-timeline": "/crm-timeline/static-1.83088",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.32089",
  "customer-data-communicator": "/customer-data-communicator/static-1.39539",
  "customer-data-email": "/customer-data-email/static-1.15523",
  "customer-data-objects": "/customer-data-objects/static-1.6216",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6176",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.40260",
  "customer-data-tracking": "/customer-data-tracking/static-1.5431",
  "data-fetching-client": "/data-fetching-client/static-1.8231",
  "dispatcher": "/dispatcher/static-1.111",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.293",
  "feedback-loader": "/feedback-loader/static-1.26238",
  "foundations-components": "/foundations-components/static-1.5789",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.650",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5385",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6932",
  "framework-data-table": "/framework-data-table/static-2.8241",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.3679",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6626",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3447",
  "hubspot-dlb": "/hubspot-dlb/static-2.1317",
  "HubStyleTokens": "/HubStyleTokens/static-2.10111",
  "I18n": "/I18n/static-7.1372",
  "immutable": "/immutable/static-2.19",
  "jasmine-console-invariants": "/jasmine-console-invariants/static-1.1327",
  "jasmine-immutable": "/jasmine-immutable/static-1.1580",
  "jasmine-runner": "/jasmine-runner/static-1.5021",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.4576",
  "MeetingsLib": "/MeetingsLib/static-2.52874",
  "msw": "/msw/static-1.39",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2670",
  "onboarding-tours": "/onboarding-tours/static-1.13932",
  "PortalIdParser": "/PortalIdParser/static-2.272",
  "quartz": "/quartz/static-1.5374",
  "quartz-core": "/quartz-core/static-1.4593",
  "quick-fetch": "/quick-fetch/static-1.2831",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.73507",
  "raven": "/raven/static-3.4440",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.51",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-dom": "/react-dom/static-7.85",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4179",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.25764",
  "reference-resolvers": "/reference-resolvers/static-1.6773",
  "reporting-dlb": "/reporting-dlb/static-1.53876",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.2893",
  "sales-clients-common": "/sales-clients-common/static-1.45072",
  "settings-ui-lib": "/settings-ui-lib/static-1.11184",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8058",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1196",
  "ui-addon-opt": "/ui-addon-opt/static-4.7280",
  "UIComponents": "/UIComponents/static-3.7060",
  "universal-associations-select": "/universal-associations-select/static-1.9402",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.2988",
  "usage-tracker": "/usage-tracker/static-1.6087",
  "usage-tracker-core": "/usage-tracker-core/static-1.5937",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-catchup-cards-lib": "/ai-catchup-cards-lib/static-1.1943",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.39908",
  "call-timeline-event": "/call-timeline-event/static-1.50080",
  "calling-error-reporting": "/calling-error-reporting/static-1.29823",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.12728",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.29614",
  "calling-ui-library": "/calling-ui-library/static-1.64076",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.32168",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14824",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14142",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30510",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.5990",
  "composer-plugins": "/composer-plugins/static-1.66133",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.29176",
  "conversations-message-history": "/conversations-message-history/static-1.9710",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.28833",
  "crm_components": "/crm_components/static-3.86173",
  "crm_schema": "/crm_schema/static-3.86210",
  "crm_universal": "/crm_universal/static-1.20355",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.40051",
  "crm-cards-dnd": "/crm-cards-dnd/static-3.832",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.14084",
  "crm-display-components": "/crm-display-components/static-1.19683",
  "crm-extension": "/crm-extension/static-1.35640",
  "crm-legacy-links": "/crm-legacy-links/static-1.71059",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.20930",
  "crm-object-preview": "/crm-object-preview/static-1.20746",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3888",
  "crm-ui-legacy-tracking-page-view": "/crm-ui-legacy-tracking-page-view/static-1.67190",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.459",
  "customer-data-filters": "/customer-data-filters/static-1.46911",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11507",
  "customer-data-properties": "/customer-data-properties/static-1.44994",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6543",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11605",
  "customer-data-rte": "/customer-data-rte/static-1.28471",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8358",
  "deal-registration-ui": "/deal-registration-ui/static-1.29540",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.38962",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.38868",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.19718",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.18986",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.19466",
  "email-confirm-ui": "/email-confirm-ui/static-2.4261",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20063",
  "ExportDialog": "/ExportDialog/static-6.9021",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.526",
  "file-manager-components": "/file-manager-components/static-1.17763",
  "FileManagerLib": "/FileManagerLib/static-1.33404",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5900",
  "foundations-assets": "/foundations-assets/static-1.3539",
  "foundations-theming": "/foundations-theming/static-1.2933",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5480",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13065",
  "HubStyle": "/HubStyle/static-2.10420",
  "icons": "/icons/static-2.591",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.16407",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9281",
  "integration-settings-components": "/integration-settings-components/static-1.10073",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.33208",
  "metrics-js": "/metrics-js/static-1.8343",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.334",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6449",
  "nav-meta": "/nav-meta/static-1.25162",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41185",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.41863",
  "playbooks-modal": "/playbooks-modal/static-1.74800",
  "playlists-lib": "/playlists-lib/static-1.6403",
  "products-ui-components": "/products-ui-components/static-1.34765",
  "property-history-panel": "/property-history-panel/static-1.18878",
  "property-translator": "/property-translator/static-1.4002",
  "react-colorpicker": "/react-colorpicker/static-2.8852",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-rhumb": "/react-rhumb/static-1.15222",
  "react-select-plus": "/react-select-plus/static-1.65",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6577",
  "reporting-action-components": "/reporting-action-components/static-1.35537",
  "reporting-data": "/reporting-data/static-1.60958",
  "reporting-enablement": "/reporting-enablement/static-1.16314",
  "reporting-ui-components": "/reporting-ui-components/static-2.58237",
  "reporting-visualizations": "/reporting-visualizations/static-1.53036",
  "rich-text-lib": "/rich-text-lib/static-1.17158",
  "rpc-client-utils": "/rpc-client-utils/static-1.3351",
  "SafeStorage": "/SafeStorage/static-1.3026",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6837",
  "sanitize-text": "/sanitize-text/static-1.6812",
  "segment-references-panel-lib": "/segment-references-panel-lib/static-1.49657",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.22318",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.22514",
  "settings-ui-nav": "/settings-ui-nav/static-2.8666",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "styled-components": "/styled-components/static-2.40",
  "subscriptions-components": "/subscriptions-components/static-1.40751",
  "timezone-utils": "/timezone-utils/static-2.3886",
  "transcript-sidebar": "/transcript-sidebar/static-1.61835",
  "transmute": "/transmute/static-2.29",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9649",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9536",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7520",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11002",
  "ui-addon-teams": "/ui-addon-teams/static-1.19512",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15771",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8821",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7498",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.11954",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8878",
  "ui-product-approvals": "/ui-product-approvals/static-1.23385",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8668",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5035",
  "usage-tracker-container": "/usage-tracker-container/static-1.6077",
  "atom": "/atom/static-1.3865",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sanitize": "/sanitize/static-1.2996",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
  "raven-hubspot": "/raven-hubspot/static-1.4747",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
  "react-redux": "/react-redux/static-7.16",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2293",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1651",
  "quartz-webpack": "/quartz-webpack/static-1.1598",
  "ably": "/ably/static-1.18",
  "hs-promise-utils": "/hs-promise-utils/static-1.4135",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.8340",
  "chatspot-core": "/chatspot-core/static-1.14830",
  "ContentUtils": "/ContentUtils/static-1.62579",
  "foundations-theming-base": "/foundations-theming-base/static-1.1918",
  "hs-story-utils": "/hs-story-utils/static-1.8014",
  "sassPrefix": "/sassPrefix/static-1.129",
  "ui-fonts": "/ui-fonts/static-1.331",
  "ui-images": "/ui-images/static-2.805",
  "graphql": "/graphql/static-1.58",
  "calling-client-interface": "/calling-client-interface/static-1.69315",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17783",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.16802",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.25028",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.50453",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4672",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5126",
  "content-assistance-lib": "/content-assistance-lib/static-1.6083",
  "conversations-async-data": "/conversations-async-data/static-2.6294",
  "conversations-prop-types": "/conversations-prop-types/static-1.6055",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6017",
  "customer-data-content": "/customer-data-content/static-1.24173",
  "immer": "/immer/static-1.33",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "self-service-api": "/self-service-api/static-1.8813",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9691",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6499",
  "onboarding-scopes": "/onboarding-scopes/static-1.5164",
  "avatar-components": "/avatar-components/static-1.1031",
  "campaigns-lib": "/campaigns-lib/static-1.21534",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.31082",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.25335",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.5573",
  "growth-payments-core": "/growth-payments-core/static-1.20579",
  "payment-link-components": "/payment-link-components/static-1.17884",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8970",
  "persist-promise": "/persist-promise/static-1.2367",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14252",
  "draft-content-plugins": "/draft-content-plugins/static-1.23793",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "FireAlarmUi": "/FireAlarmUi/static-1.3490",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.11540",
  "react-virtualized": "/react-virtualized/static-2.73",
  "reselect": "/reselect/static-2.16",
  "sequences-lib": "/sequences-lib/static-1.5651",
  "superstore": "/superstore/static-1.3404",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.21198",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.9001",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2797",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1200",
  "crm-events-components": "/crm-events-components/static-1.54748",
  "hub-http-contrib": "/hub-http-contrib/static-1.1802",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd-compat": "/react-dnd-compat/static-1.3268",
  "task-forms-lib": "/task-forms-lib/static-1.35254",
  "task-queues": "/task-queues/static-1.28039",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7397",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.38583",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.49353",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.67344",
  "card-lists-lib": "/card-lists-lib/static-1.65553",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.36077",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.57627",
  "card-target-account-lib": "/card-target-account-lib/static-1.67054",
  "invoices-card-lib": "/invoices-card-lib/static-1.51070",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3426",
  "crm-actions": "/crm-actions/static-1.4683",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.34938",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.2060",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.13269",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.67418",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.27920",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.35584",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.20517",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33096",
  "customer-data-modals": "/customer-data-modals/static-1.3392",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.9794",
  "merge-modal-lib": "/merge-modal-lib/static-1.6148",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.21929",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.24098",
  "property-description-translator": "/property-description-translator/static-1.2466",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.5902",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2625",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51590",
  "outpost": "/outpost/static-1.2960",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2726",
  "user-context": "/user-context/static-1.3778",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.30785",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4198",
  "analytics_js": "/analytics_js/static-1.3169",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17781",
  "crm-events": "/crm-events/static-1.54755",
  "feedback-schema": "/feedback-schema/static-1.47888",
  "FileManagerCore": "/FileManagerCore/static-1.33263",
  "flux-actions": "/flux-actions/static-1.266",
  "forms-utils-lib": "/forms-utils-lib/static-1.9954",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.80347",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3335",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11498",
  "integrations-lib": "/integrations-lib/static-1.9833",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4096",
  "MeetingsBase": "/MeetingsBase/static-1.54466",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.34245",
  "project-storage": "/project-storage/static-1.3323",
  "ql-visibility-lib": "/ql-visibility-lib/static-1.3940",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.41846",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.36884",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.95464",
  "react-table": "/react-table/static-1.15",
  "report-customization-components": "/report-customization-components/static-1.8209",
  "reporting-snowflake": "/reporting-snowflake/static-1.49580",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7565",
  "salesImages": "/salesImages/static-1.498",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5507",
  "share-transcript-modal": "/share-transcript-modal/static-1.51480",
  "social-components-lib": "/social-components-lib/static-1.28351",
  "StyleGuideUI": "/StyleGuideUI/static-3.453",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.13087",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6609",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8237",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3823",
  "ui-tour-react": "/ui-tour-react/static-1.10584",
  "urlinator": "/urlinator/static-1.3166",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13057",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.2380",
  "quotes-client-types": "/quotes-client-types/static-1.30875",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2626",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2774",
  "external-options-client-types": "/external-options-client-types/static-1.2938",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3062",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.32933",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.48926",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.16636",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.12530",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.64796",
  "wootric-nps": "/wootric-nps/static-1.5579",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2057",
  "floating-ui": "/floating-ui/static-1.28",
  "framer-motion": "/framer-motion/static-1.40",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2972",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2910",
  "customer-data-associations": "/customer-data-associations/static-1.5828",
  "testing-library": "/testing-library/static-1.120",
  "HeadJS": "/HeadJS/static-2.563",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1737",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.2971",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3274",
  "laboratory-lib": "/laboratory-lib/static-3.5879",
  "react-transition-group": "/react-transition-group/static-1.7",
  "redux-actions": "/redux-actions/static-3.7",
  "signup-constants": "/signup-constants/static-1.15857",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.17867",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6671",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4504",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4501",
  "usage-tracker-public": "/usage-tracker-public/static-1.5898",
  "viral-links-lib": "/viral-links-lib/static-1.5485",
  "ts-schema": "/ts-schema/static-1.2990",
  "growth-data-modal": "/growth-data-modal/static-1.3821",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1728",
  "navigation-components": "/navigation-components/static-1.13525",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6049",
  "ui-universal-auth": "/ui-universal-auth/static-1.7419",
  "quartz-core-utils": "/quartz-core-utils/static-1.2241",
  "hub-http-janus": "/hub-http-janus/static-1.635",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6846",
  "hubspotter-http": "/hubspotter-http/static-1.3420",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6844",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11022",
  "csstype": "/csstype/static-1.38",
  "call-summary": "/call-summary/static-1.31468",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.5582",
  "reporting-client-types": "/reporting-client-types/static-1.1767",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.21906",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9089",
  "rxjs": "/rxjs/static-5.10",
  "react-flip-move": "/react-flip-move/static-1.46",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10031",
  "crm-properties-list": "/crm-properties-list/static-1.32958",
  "activity-history-lib": "/activity-history-lib/static-1.1328",
  "assisted-buying-components": "/assisted-buying-components/static-1.5618",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.11660",
  "company-details-components": "/company-details-components/static-1.4518",
  "company-details-service-types": "/company-details-service-types/static-1.2549",
  "final-form": "/final-form/static-1.39",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.998",
  "industries-core": "/industries-core/static-1.5381",
  "payment-method-components": "/payment-method-components/static-1.5164",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.8932",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2241",
  "conversations-calling-message": "/conversations-calling-message/static-1.53856",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.16541",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.29839",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3133",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.50",
  "worker-connection-library": "/worker-connection-library/static-1.11096",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "cv-backend-services": "/cv-backend-services/static-1.1110",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3792",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17058",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3709",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7544",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11272",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7574",
  "composer-data": "/composer-data/static-1.25009",
  "conversations-http": "/conversations-http/static-1.3416",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14632",
  "conversations-platform": "/conversations-platform/static-1.3116",
  "conversations-thread-data": "/conversations-thread-data/static-1.62169",
  "ui-addon-conversations-settings": "/ui-addon-conversations-settings/static-2.27008",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5633",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.39323",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.2886",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.12460",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.4568",
  "buyer-intent-card": "/buyer-intent-card/static-1.15615",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.29669",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.20551",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.1767",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.10796",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.424",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.10796",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.2383",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.3765",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6712",
  "card-lead-insights": "/card-lead-insights/static-1.8926",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.24552",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.1068",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2737",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.25371",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.19736",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.1814",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9577",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11424",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.33912",
  "crm-associations-table": "/crm-associations-table/static-1.35782",
  "crm-clv-report": "/crm-clv-report/static-1.2570",
  "crm-data-highlights": "/crm-data-highlights/static-1.36320",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.35576",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.27129",
  "crm-property-history": "/crm-property-history/static-1.11018",
  "crm-quick-actions": "/crm-quick-actions/static-1.12468",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.12896",
  "crm-report": "/crm-report/static-1.36527",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.13114",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.31491",
  "crm-statistics": "/crm-statistics/static-1.25536",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.291",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.4139",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.12240",
  "deal-summary-components": "/deal-summary-components/static-1.15099",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.21965",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.1286",
  "guided-actions-card": "/guided-actions-card/static-1.8799",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.5920",
  "health-score-card-lib": "/health-score-card-lib/static-1.15523",
  "help-desk-insights-lib-crm-cards": "/help-desk-insights-lib-crm-cards/static-1.17750",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.9447",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.7699",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.25354",
  "lead-scores-card": "/lead-scores-card/static-1.11907",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.29119",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.22699",
  "playbooks-card": "/playbooks-card/static-1.37510",
  "predictive-scores-card": "/predictive-scores-card/static-1.25096",
  "process-guide-cards": "/process-guide-cards/static-1.3363",
  "products-cards-lib": "/products-cards-lib/static-1.3839",
  "purchase-history-lib": "/purchase-history-lib/static-1.15039",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.1136",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.1138",
  "crm-component-utils": "/crm-component-utils/static-1.33933",
  "content-embed-lib": "/content-embed-lib/static-1.5976",
  "remote-ui": "/remote-ui/static-1.39",
  "ui-extensions": "/ui-extensions/static-1.14361",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.8895",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.4926",
  "deep-diff": "/deep-diff/static-1.5",
  "commerce-products-lib": "/commerce-products-lib/static-1.4245",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "media-bridge-lib": "/media-bridge-lib/static-1.16424",
  "video-data-lib": "/video-data-lib/static-1.28780",
  "FileManagerImages": "/FileManagerImages/static-1.30914",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1416",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.7617",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8547",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.13107",
  "marketplace-embed": "/marketplace-embed/static-1.15684",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2640",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4251",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1558",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.32238",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.12659",
  "dashboard-lib": "/dashboard-lib/static-1.75057",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7272",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7392",
  "html-to-image": "/html-to-image/static-1.29",
  "reporting-plugins": "/reporting-plugins/static-1.6397",
  "reporting-reports": "/reporting-reports/static-1.60643",
  "data-token-picker": "/data-token-picker/static-1.13812",
  "account-and-billing-components": "/account-and-billing-components/static-1.16084",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4120",
  "subscriptions-client": "/subscriptions-client/static-1.40991",
  "magpie-lib": "/magpie-lib/static-1.4303",
  "navigation-messaging": "/navigation-messaging/static-1.2852",
  "feature-store-service-types": "/feature-store-service-types/static-1.3289",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3296",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3280",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2819",
  "cms-field-types": "/cms-field-types/static-1.3402",
  "content-icons-ui": "/content-icons-ui/static-1.1863",
  "attribution-lib": "/attribution-lib/static-1.36959",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.6945",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5284",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.5571",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3139",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3770",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3833",
  "fsm": "/fsm/static-1.2321",
  "policy-lib": "/policy-lib/static-1.5422",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.1019",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4583",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.50999",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.48941",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15529",
  "automation-ui-core": "/automation-ui-core/static-2.15293",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13655",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.10847",
  "markdown-it": "/markdown-it/static-1.6",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.22493",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10616",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5669",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.21883",
  "audio-components": "/audio-components/static-1.4234",
  "video-components": "/video-components/static-1.7132",
  "video-embed": "/video-embed/static-1.29621",
  "forms-ai-lib": "/forms-ai-lib/static-1.2032",
  "react-tinymce": "/react-tinymce/static-1.49947",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1292",
  "tinymce-config": "/tinymce-config/static-2.49073",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7248",
  "meetings-client-types": "/meetings-client-types/static-1.2680",
  "portal-details-components": "/portal-details-components/static-1.13341",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6708",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5081",
  "messaging-types-lib": "/messaging-types-lib/static-1.39671",
  "products-iframe-lib": "/products-iframe-lib/static-1.2270",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7231",
  "emoji-regex": "/emoji-regex/static-1.7",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3763",
  "simple-logging-lib": "/simple-logging-lib/static-1.1665",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6539",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.6992",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2355",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.17542",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.9996",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2703",
  "buying-experience-components": "/buying-experience-components/static-1.8427",
  "checkout-service-types": "/checkout-service-types/static-1.2791",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.7684",
  "trellis-story-utils": "/trellis-story-utils/static-1.3177",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12002",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4947",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.5588",
  "immutable-less": "/immutable-less/static-1.3182",
  "routing-ui": "/routing-ui/static-1.15285",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4385",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.3947",
  "re-reselect": "/re-reselect/static-1.4",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2549",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2055",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.1407",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2801",
  "recent-activities-card": "/recent-activities-card/static-1.52612",
  "submissions-lib": "/submissions-lib/static-1.40841",
  "ui-forms-components": "/ui-forms-components/static-1.7949",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.6242",
  "customer-success-client-types": "/customer-success-client-types/static-1.14059",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.11167",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.12878",
  "guided-actions-lib": "/guided-actions-lib/static-1.14030",
  "property-management-iframe": "/property-management-iframe/static-1.7768",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.71068",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.61809",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.71075",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.71089",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.71090",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.71089",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.62993",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.38348",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.39955",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.39956",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.41453",
  "card-invoices-lib": "/card-invoices-lib/static-1.50435",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.50217",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.50216",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.31981",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.30947",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.51109",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.78315",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.32238",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.71230",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.50287",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.67869",
  "card-workflows-lib": "/card-workflows-lib/static-1.67244",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.21265",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.31194",
  "orders-card-lib": "/orders-card-lib/static-1.16353",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.13691",
  "recording-preview-card": "/recording-preview-card/static-1.11114",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.34918",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.26250",
  "sales-execution-components": "/sales-execution-components/static-1.7530",
  "process-guide-chirp": "/process-guide-chirp/static-1.3195",
  "gapi-client-types": "/gapi-client-types/static-1.3",
  "google-picker-types": "/google-picker-types/static-1.3",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.707",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10872",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13466",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.3366",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4312",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2125",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14834",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11703",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11699",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4339",
  "automation-ui-routing": "/automation-ui-routing/static-1.14717",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12439",
  "immerable": "/immerable/static-1.2789",
  "social-insights-client-types": "/social-insights-client-types/static-1.17255",
  "tinymce-themes": "/tinymce-themes/static-1.51043",
  "interframe": "/interframe/static-3.3421",
  "tinymce-data": "/tinymce-data/static-1.35158",
  "tinymce-plugins": "/tinymce-plugins/static-1.52187",
  "user-configuration-lib": "/user-configuration-lib/static-1.23935",
  "ContentData": "/ContentData/static-1.62655",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1408",
  "sales-views-client-types": "/sales-views-client-types/static-1.2969",
  "ui-signature-editor": "/ui-signature-editor/static-1.13228",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8700",
  "stripe-connect-js": "/stripe-connect-js/static-1.37",
  "form-builder-ui": "/form-builder-ui/static-1.7723",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15164",
  "react-window": "/react-window/static-1.13",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9720",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.13425",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.7640",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8082",
  "codemirror": "/codemirror/static-5.69",
  "layout-dnd-components": "/layout-dnd-components/static-1.10559",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9534",
  "react-codemirror": "/react-codemirror/static-1.9223",
  "app-users-service-client": "/app-users-service-client/static-1.3655",
  "app-users-service-types": "/app-users-service-types/static-1.3061",
  "framework-listing-lib": "/framework-listing-lib/static-2.21685",
  "mini-checkout-client": "/mini-checkout-client/static-1.23824",
  "onboarding-utils": "/onboarding-utils/static-1.3967",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.21891",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2924",
  "academy-common-lib": "/academy-common-lib/static-1.9180",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "layout-data-lib": "/layout-data-lib/static-1.7859",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.21801",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6737",
  "touchless-buying-components": "/touchless-buying-components/static-1.3066",
  "merchandise-lib": "/merchandise-lib/static-1.221",
  "settings-content-modals": "/settings-content-modals/static-1.39199",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "zustand": "/zustand/static-1.45",
  "crm-export-dialog": "/crm-export-dialog/static-1.4926",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.4995",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "checkout-sdk": "/checkout-sdk/static-3.20667",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2544",
  "access-control-lib": "/access-control-lib/static-1.9093",
  "EmailComponents": "/EmailComponents/static-1.48347",
  "EmailData": "/EmailData/static-1.47023",
  "redux-less": "/redux-less/static-2.8055",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.602",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "ContentComponents": "/ContentComponents/static-2.65536",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7755",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.39935",
  "ui-tool-access": "/ui-tool-access/static-1.8669",
  "automation-ui-types": "/automation-ui-types/static-1.13357",
  "data-token-views": "/data-token-views/static-1.13793",
  "simple-menus-core": "/simple-menus-core/static-1.13332",
  "simple-menus-lib": "/simple-menus-lib/static-1.14850",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27636",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4733",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2462",
  "ContentEditorUI": "/ContentEditorUI/static-2.70973",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2791",
  "web-interactives-components": "/web-interactives-components/static-1.11235",
  "web-interactives-data": "/web-interactives-data/static-1.11236",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3675",
  "copilot-plugins": "/copilot-plugins/static-1.5564",
  "cta-picker": "/cta-picker/static-1.30683",
  "editor-components": "/editor-components/static-1.11641",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.6920",
  "error-messaging-js": "/error-messaging-js/static-1.3912",
  "pictos": "/pictos/static-7.158",
  "redux-request-state": "/redux-request-state/static-1.9198",
  "smart-content-core": "/smart-content-core/static-1.36638",
  "smart-content-lib": "/smart-content-lib/static-1.37291",
  "social-composer-lib": "/social-composer-lib/static-1.52760",
  "structured-content-lib": "/structured-content-lib/static-1.19569",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.47206",
  "tinymce-copilot": "/tinymce-copilot/static-1.11141",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.31122",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5698",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.4429",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.7800",
  "fuzzy": "/fuzzy/static-1.8",
  "codemirror-dlb": "/codemirror-dlb/static-1.52527",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
